// extracted by mini-css-extract-plugin
export var activityContainer = "_k1-0";
export var typingIndicatorContainer = "_k1-1";
export var typingIndicatorDot = "_k1-2";
export var wave = "_k1-3";